import { render, staticRenderFns } from "./ViewPropertyChangeRequestsLegacy.vue?vue&type=template&id=2ae2a693"
import script from "./ViewPropertyChangeRequestsLegacy.vue?vue&type=script&lang=ts"
export * from "./ViewPropertyChangeRequestsLegacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports